import React, { useState, useEffect } from "react";
import { Button, Modal, Tooltip, Form, Input, Select, Upload } from "antd";
import {
  PlusOutlined,
  BugOutlined,
  RetweetOutlined,
  ToolOutlined,
  LikeOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { post } from "../../services/services";
import { ApiURL } from "../../services/apiConstants";
import { SuccessToast, ErrorToast } from "../../widgets/AppToast";


const { TextArea } = Input;
const { Option } = Select;

const FloatingFabCompanyModal = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const [modalType, setModalType] = useState("");  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [severityOptions, setSeverityOptions] = useState([]);
  const [priorityOptions, setPriorityOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [shipList, setShipList] = useState([]);

  const [form] = Form.useForm(); // IMPORTANT for submit + reset

  const openModal = (type) => {
    setModalType(type);
    setIsModalOpen(true);
    setOpenMenu(false);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalType("");
    form.resetFields();
  };

 const fetchShipList = async () => {
  try {
    const res = await post(ApiURL.dashboard_ship_details_com, new FormData());
    if (res?.status) {
      setShipList(res.ship_list || []);
    }
  } catch (err) {
    console.error("Failed to fetch ship list:", err);
  }
};

  // useEffect(() => {
  //   fetchShipList();
  // }, [])

  useEffect(() => {
  if (isModalOpen) {
    fetchShipList(); 
  }
}, [isModalOpen]);

  const fetchSeverityOptions = async () => {
    try {
      const formData = new FormData();
      formData.append("login_token", localStorage.getItem("login_token"));
      formData.append("refresh_token", localStorage.getItem("refresh_token"));

      const res = await post(ApiURL.bug_severity_options_com, formData);

      if (res?.status) {
        setSeverityOptions(res.data);
      } else {
        ErrorToast("Error:", res.message);
      }
    } catch (err) {
      ErrorToast("Error:", "Failed to load severity options!");
    }
  };

  // useEffect(() => {
  //   if (modalType === "bug") {
  //     fetchSeverityOptions();
  //   }
  // }, [modalType]);
  useEffect(() => {
  if (modalType === "bug") {
    fetchSeverityOptions();
  }
  if (modalType === "feature") {
    fetchPriorityOptions();
  }
}, [modalType]);


  /* -----------------------------------------
      SUBMIT BUG REPORT API
  --------------------------------------------*/
  const handleBugSubmit = async (values) => {
    setLoading(true);

    try {
      const formData = new FormData(); // Proper form-data

      formData.append("login_token", localStorage.getItem("login_token"));
      formData.append("refresh_token", localStorage.getItem("refresh_token"));
      // formData.append("ship_id", shipId);
      formData.append("ship_id", values.ship_id);
      formData.append("title", values.title);
      formData.append("description", values.description);
      formData.append("severity", values.severity);

      if (values.attachment && values.attachment.fileList.length > 0) {
        formData.append(
          "attachment",
          values.attachment.fileList[0].originFileObj
        );
      }

      const res = await post(ApiURL.bug_report_com, formData);

      if (res?.status) {
        SuccessToast("Success:", "Bug Report Submitted Successfully!");
        closeModal();
      } else {
        ErrorToast("Bug Error:", res?.message);
      }
    } catch (err) {
      ErrorToast("Bug Error:", "Something went wrong!");
    }

    setLoading(false);
  };

  const handleChangeRequestSubmit = async (values) => {
  setLoading(true);

  try {
    const formData = new FormData();

    formData.append("login_token", localStorage.getItem("login_token"));
    formData.append("refresh_token", localStorage.getItem("refresh_token"));
    // formData.append("ship_id", shipId);
    formData.append("ship_id", values.ship_id);
    formData.append("title", values.title);
    formData.append("description", values.description);

    if (values.attachment && values.attachment.fileList.length > 0) {
      formData.append(
        "attachment",
        values.attachment.fileList[0].originFileObj
      );
    }

    const res = await post(ApiURL.change_request_com, formData);

    if (res?.status) {
      SuccessToast("Success:", "Change Request Submitted Successfully!");
      closeModal();
    } else {
      ErrorToast("Change Error:", res?.message);
    }
  } catch (err) {
    ErrorToast("Change Error:", "Something went wrong!");
  }

  setLoading(false);
};

const fetchPriorityOptions = async () => {
  try {
    const formData = new FormData();
    formData.append("login_token", localStorage.getItem("login_token"));
    formData.append("refresh_token", localStorage.getItem("refresh_token"));

    const res = await post(ApiURL.priority_options_com, formData);

    if (res?.status) {
      setPriorityOptions(res.data);
    } else {
      ErrorToast("Error:", res.message);
    }
  } catch (err) {
    ErrorToast("Error:", "Failed to load priority options!");
  }
};

/* -----------------------------------------
      SUBMIT FEATURE REQUEST API
--------------------------------------------*/
const handleFeatureRequestSubmit = async (values) => {
  setLoading(true);

  try {
    const formData = new FormData();

    formData.append("login_token", localStorage.getItem("login_token"));
    formData.append("refresh_token", localStorage.getItem("refresh_token"));
    // formData.append("ship_id", shipId);
    formData.append("ship_id", values.ship_id);
    formData.append("title", values.title);
    formData.append("description", values.description);
    formData.append("priority", values.priority);
    formData.append("whyneeded", values.why_needed);

    if (values.attachment && values.attachment.fileList.length > 0) {
      formData.append("attachment", values.attachment.fileList[0].originFileObj);
    }

    const res = await post(ApiURL.feature_request_com, formData);

    if (res?.status) {
      SuccessToast("Success:", "Feature Request Submitted Successfully!");
      closeModal();
    } else {
      ErrorToast("Feature Error:", res?.message);
    }
  } catch (err) {
    ErrorToast("Feature Error:", "Something went wrong!");
  }

  setLoading(false);
};

/* -----------------------------------------
      SUBMIT FEEDBACK API
--------------------------------------------*/
const handleFeedbackSubmit = async (values) => {
  setLoading(true);

  try {
    const formData = new FormData();

    formData.append("login_token", localStorage.getItem("login_token"));
    formData.append("refresh_token", localStorage.getItem("refresh_token"));
    // formData.append("ship_id", shipId);
    formData.append("ship_id", values.ship_id);
    formData.append("title", values.title);
    formData.append("description", values.description);

    if (values.attachment && values.attachment.fileList.length > 0) {
      formData.append("attachment", values.attachment.fileList[0].originFileObj);
    }

    const res = await post(ApiURL.feedback_com, formData);

    if (res?.status) {
      SuccessToast("Success:", "Feedback Submitted Successfully!");
      closeModal();
    } else {
      ErrorToast("Feedback Error:", res?.message);
    }
  } catch (err) {
    ErrorToast("Feedback Error:", "Something went wrong!");
  }

  setLoading(false);
};

  return (
    <>
      {/* Floating Button */}
      <div style={styles.fabContainer}>
        {openMenu && (
          <div style={styles.menuContainer}>
            <Tooltip title="Report Bug" placement="left">
              <Button
                style={styles.childBtn}
                shape="circle"
                icon={<BugOutlined />}
                onClick={() => openModal("bug")}
              />
            </Tooltip>

            <Tooltip title="Change Request" placement="left">
              <Button
                style={styles.childBtn}
                shape="circle"
                icon={<RetweetOutlined />}
                onClick={() => openModal("change")}
              />
            </Tooltip>

            <Tooltip title="Feature Request" placement="left">
              <Button
                style={styles.childBtn}
                shape="circle"
                icon={<ToolOutlined />}
                onClick={() => openModal("feature")}
              />
            </Tooltip>

            <Tooltip title="Feedback" placement="left">
              <Button
                style={styles.childBtn}
                shape="circle"
                icon={<LikeOutlined />}
                onClick={() => openModal("feedback")}
              />
            </Tooltip>
          </div>
        )}

        {/* <Button
          type="primary"
          shape="circle"
          size="large"
          icon={<PlusOutlined />}
          onClick={() => setOpenMenu(!openMenu)}
        /> */}
<Tooltip title="Issues & Requests" placement="left">
  <Button
    type="primary"
    shape="circle"
    size="large"
    icon={<PlusOutlined />}
    onClick={() => setOpenMenu(!openMenu)}
  />
</Tooltip>
      </div>

      {/* --------------------------- Modal --------------------------- */}
      <Modal
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
        title={
          modalType === "bug"
            ? "Report a Bug"
            : modalType === "change"
            ? "Submit Change Request"
            : modalType === "feature"
            ? "Feature Request"
            : "Send Feedback"
        }
      >
        {/* <Form form={form} layout="vertical" onFinish={handleBugSubmit}> */}
            <Form
      form={form}
      layout="vertical"
      // onFinish={
      //   modalType === "bug"
      //     ? handleBugSubmit
      //     : modalType === "change"
      //     ? handleChangeRequestSubmit
      //     : null
      // }
      onFinish={
  modalType === "bug"
    ? handleBugSubmit
    : modalType === "change"
    ? handleChangeRequestSubmit
    : modalType === "feature"
    ? handleFeatureRequestSubmit
    : modalType === "feedback"
    ? handleFeedbackSubmit
    : null
}

    >
          <Form.Item 
          name="ship_id" 
          label="Select Ship" 
          rules={[{ required: true, message: "Please select a ship" }]}
          >
          <Select placeholder="Choose a ship">
            {shipList.map((ship) => (
              <Option key={ship.id} value={ship.id}>
                {ship?.vessel_name}
              </Option>
            ))}
          </Select>
        </Form.Item>

          <Form.Item name="title" label="Title" rules={[{ required: true }]}>
            <Input placeholder="Enter title" />
          </Form.Item>

          <Form.Item
            name="description"
            label="Description"
            rules={[{ required: true }]}
          >
            <TextArea rows={3} placeholder="Write your details..." />
          </Form.Item>

          {/* Severity For Bug */}
          {modalType === "bug" && (
            <Form.Item name="severity" label="Severity" rules={[{ required: true }]}>
              <Select placeholder="Select severity">
                {severityOptions.map((item) => (
                  <Option key={item.key} value={item.key}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}
            {modalType === "feature" && (
    <Form.Item
      name="why_needed"
      label="Why is this feature needed?"
      rules={[{ required: true, message: "Please explain why this feature is needed" }]}
    >
      <TextArea
        rows={3}
        placeholder="Describe the reason behind this request. What problem will this feature solve?"
      />
    </Form.Item>
  )}

  {/* Feature Priority */}
  {modalType === "feature" && (
  <Form.Item
    name="priority"
    label="Priority"
    rules={[{ required: true }]}
  >
    <Select placeholder="Select priority">
      {priorityOptions.map((item) => (
        <Option key={item.key} value={item.key}>
          {item.label}
        </Option>
      ))}
    </Select>
  </Form.Item>
)}

          <Form.Item name="attachment" label="Attachment (optional)">
            <Upload beforeUpload={() => false}>
              <Button icon={<UploadOutlined />}>Upload</Button>
            </Upload>
          </Form.Item>

          <Button
            type="primary"
            block
            loading={loading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </Form>
      </Modal>
    </>
  );
};

export default FloatingFabCompanyModal;

/* --------------------- Styles -------------------- */
const styles = {
  fabContainer: {
    position: "fixed",
    bottom: 30,
    right: 30,
    zIndex: 9999,
  },
  menuContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    marginBottom: 10,
    alignItems: "flex-end",
  },
  childBtn: {
    background: "#fff",
    border: "1px solid #ccc",
  },
};
